export default [
    {
        path: '/perkin',
        redirect: '/perkin',
        name: 'perkin',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'perkinIndex',
                component: () => import('@/views/perkin/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'perkin',
                    pageTitle: 'Perkin',
                    breadcrumb: [
                        {
                            text: 'Perkin',
                            active: true,
                        },
                    ],
                },
            },
            {
                path: '/perkin/input',
                name: 'perkinInput',
                component: () => import('@/views/perkin/Tambah.vue'),
                meta: {
                    action: 'Buat',
                    resource: 'perkin',
                    pageTitle: 'Input Perkin',
                    breadcrumb: [
                        {
                            text: 'Perkin',
                        },
                        {
                            text: 'Input',
                            active: true,
                        },
                    ],
                },
            },
            // {
            //     path: '/setup/ubah/:id',
            //     name: 'setupUbah',
            //     component: () => import('@/views/setup/Ubah.vue'),
            //     meta: {
            //         action: 'Ubah',
            //         resource: 'setup',
            //         pageTitle: 'Ubah Setup',
            //         breadcrumb: [
            //             {
            //                 text: 'Setup',
            //             },
            //             {
            //                 text: 'Ubah',
            //                 active: true,
            //             },
            //         ],
            //     },
            //     props: true
            // },
        ]
    }
]